import { render, staticRenderFns } from "./ResumeSection.vue?vue&type=template&id=06973d62&scoped=true"
import script from "./ResumeSection.vue?vue&type=script&lang=js"
export * from "./ResumeSection.vue?vue&type=script&lang=js"
import style0 from "./ResumeSection.vue?vue&type=style&index=0&id=06973d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06973d62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
